/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Shape from "App/geometry/objects/shape";
import {FLOAT_PRECISION} from "App/math";
import ModelDescription from "App/model/description";
import {RenderElement} from "App/model/elements/element";
import Binary from "App/geometry/objects_geometry/binary";
import GeometryFactory from "App/geometry/objects_geometry/factory";
import Factory from "App/geometry/objects/factory";
import ShapeBatchNode from "App/render/webgl/nodes/shape_batch_node";
import LineBatch from "App/render/webgl/renderables/batches/line_batch";
import {LineTypeName} from "App/geometry/objects/type_names";

export default
class Line extends Shape {

    public static TypeName: string = LineTypeName;

    constructor(aUID: number) {
        super(aUID);

        this._forceHidden = false; // because of turning of outlines (seeSceneAPI.RenderSettingsModule.prototype.setShowOutlines)
        this.properties.canCastShadow = false;
    }

    public static create(aUID: number): Line {
        return new Line(aUID);
    };

    public getPrimitiveSize(): number {
        if (this.getRenderAsOutline()) {
            return 2;
        }
        return 3;
    }

    /**
     * In case the line has width of 1 px and is filled, then we rather render the line as outline because the outlines are rendered via line primitives wheresa
     * lines are rendered as volumes using triangles with special shader which is slower.
     * @returns {boolean}
     */
    public getRenderAsOutline(): boolean {
        return this.appearance && this.appearance.lineProperties &&
            Math.abs(this.appearance.lineProperties.getLinewidthScaleFactor() - 1.0) < FLOAT_PRECISION &&
            this.appearance.lineProperties.getLineType() === -1;
    }

    public parse(aModelDescription: ModelDescription, aShapeJSON: any, aElement: RenderElement) {
        super.parse(aModelDescription, aShapeJSON, aElement);

        let geomTypePair = GeometryFactory.create(aShapeJSON, this);

        // do not use Factory.create method as we need to decide the geometry
        // instance based on the renderAsOutline decision
        if (this.getRenderAsOutline()) {
            this.geometry = new Binary(this);
        } else {
            this.geometry = geomTypePair.geometry;
        }
        this.geometry.parse(aShapeJSON[geomTypePair.type]);
    }
}

Factory.register(Line);
ShapeBatchNode.registerGeometryObject(Line.TypeName, LineBatch);
